import { ChainId } from '../../utils/config/networks';
export const explorers = {
    250: 'https://ftmscan.com/tx/',
    [ChainId.ETHEREUM]: 'https://etherscan.io/tx/',
    [ChainId.BSC]: 'https://bscscan.com/tx/',
    [ChainId.POLYGON]: 'https://polygonscan.com/tx/',
    [ChainId.AVALANCHE]: 'https://snowtrace.io/tx/',
    [ChainId.ARBITRUM]: 'https://arbiscan.io/tx/',
    [ChainId.OPTIMISM]: 'https://optimistic.etherscan.io/tx/',
    [ChainId.BASE]: 'https://basescan.org/tx/',
    [ChainId.SOLANA]: 'https://solscan.io/tx/',
    [ChainId.SOLANA_DLN]: 'https://solscan.io/tx/',
    [ChainId.SOLANA_OKX]: 'https://solscan.io/tx/',
    [ChainId.SUI]: 'https://suiscan.xyz/mainnet/tx/',
    [ChainId.APTOS]: 'https://aptoscan.com/transaction/',
};
export const networkNames = {
    [ChainId.BSC]: 'Binance Smart Chain',
    [ChainId.ETHEREUM]: 'Ethereum',
    [ChainId.POLYGON]: 'Polygon',
    [ChainId.AVALANCHE]: 'Avalanche',
    [ChainId.ARBITRUM]: 'Arbitrum',
    [ChainId.OPTIMISM]: 'Optimism',
    [ChainId.BASE]: 'Base',
    [ChainId.SOLANA]: 'Solana',
    [ChainId.SOLANA_DLN]: 'Solana',
    [ChainId.SOLANA_OKX]: 'Solana',
    [ChainId.SUI]: 'Sui',
    [ChainId.APTOS]: 'Aptos',
};
